import {
  updateCardSize,
  updateCardOrder 
} from '@/api/dashboard'

export const cardSizePositionMixins = {
  created () {
    this.customer_id = localStorage.getItem('customer_id')
  },
  methods: {
    async resizeCard (card_id, size) {
      try {
        const payload = { id: card_id, column_width: size }
        await updateCardSize(this.customer_id, payload)
      } catch (e) {
        console.log(e)
      }
    },
    async reorderCards (card_order) {
      try {
        const payload = { cards: card_order }
        await updateCardOrder(this.customer_id, payload)
      } catch (e) {
        console.log(e)
      }
    }
  }
}